<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>美金挂卖</div>
		<div><router-link to="/my/publishSellRecord">记录</router-link></div>
	</header>
	<div class="z-body z-padding10">
				<v-select
					:items="banklist"
					item-text="bank"
					item-value="id"
					v-model="select"
					label="收款银行卡"
				></v-select>
					

		<v-text-field :label="'交易数量（最大可交易数量'+balance+'币）'" :rules="rules" v-model="amount"></v-text-field>
		
		<p class="z-p">重要提醒</p>
		<p class="z-p z-p-describe" v-html="tips"></p>
		<div class="z-btn-long z-full-width" @click="onpost">发布</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'publish',
	data() {
		return {
			balance:0,
			amount:0,
			banklist: [],
			select:0,
			rules: [
		        value => !!value || '请选择银行卡'
		    ],
		    tips:''
		}
	},
	created() {
		this.get('api/Agora/mine',{}).then((rs)=>{
			this.balance = rs.data.balance
			this.banklist = rs.data.bank
			this.tips = rs.data.tips
		})
	},
	methods: {
		onpost(){
			this.post('api/Agora/publish',{bankid:this.select,amount:this.amount}).then((rs)=>{
				this.$store.commit('layer',rs.msg)
				if (rs.code==0) {
					this.jump('/my/publishSellRecord')
				}
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-p{
	margin:10px 0px;
}
.z-p-describe {
	color: #8F8E8E;
	margin-bottom: 100px;
}

</style>



// WEBPACK FOOTER //
// src/pages/my/publish.vue